module.exports = __webpack_public_path__ + "img/stema.b66f4103.jpg";